import type { To } from 'react-router';

import { hasPreviousLocation } from '#src/lib/routing.tsx';

export const getSafePreviousLocation = (
  defaultPreviousLocation: string | To,
  delta?: number
) => {
  const backDelta = delta || -1;

  if (hasPreviousLocation(backDelta)) {
    return backDelta as To;
  }
  return defaultPreviousLocation;
};
